import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';

import Label from '../../../../components/Label';
import Input from '../../../../components/Input';
import messages from './messages';
import '../styles.css';

// had to use <React.Fragment> to be able to test
// https://github.com/airbnb/enzyme/issues/2056
export default function TopAreasOfStudy({ onChange, initialValue }) {
  return (
    <React.Fragment>
      {
        range(1, 6).map((index) => (
          <div styleName="field" key={index}>
            <Label styleName="menu-field-label" as="label" htmlFor={`top-area-of-study-${index}`}>
              {`${messages.popularAreaOfStudy.defaultMessage} #${index}`}
            </Label>
            <Input
              fluid
              id={`top-area-of-study-${index}`}
              name={`topAreasOfStudy${index}`}
              value={initialValue[index].value}
              onChange={(e, { value }) => {
                onChange(e, { [index]: { ...initialValue[index], value } });
              }}
            />
          </div>
        ))
      }
    </React.Fragment>
  );
}

TopAreasOfStudy.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};
